import { isLeadContacted } from 'pages/pga-coach/leads/utils'

export const RECOMMENDED_STEP_IDS = {
  LESSON_PACK: 'lesson-pack',
  RECURRING_AVAILABILITY: 'recurring-availability',
  LEADS_AUTO_REPLY: 'leads-auto-reply',
  MARK_OFF_PLATFORM_CONTACTS: 'mark-off-platform-contacts',
  GROUP_CLINIC: 'group-clinic',
  UPDATE_LESSON_RATES: 'update-lesson-rates',
  ON_COURSE_PLAYING_LESSON: 'on-course-playing-lesson',
}

const hasLessonPack = lessonTypes =>
  (lessonTypes ?? []).some(
    lessonType => (lessonType.lessonPacks?.length ?? 0) > 0,
  )

const hasRecurringAvailability = coachAvailabilities =>
  (coachAvailabilities ?? []).some(
    availability => (availability.timeSlots?.length ?? 0) > 0,
  )

const hasActiveGroupEvent = groupEvents =>
  (groupEvents ?? []).some(event => !event.isCanceled)

const hasOnCourseLessonType = lessonTypes =>
  (lessonTypes ?? []).some(lessonType => lessonType.category === 'ON_COURSE')

const hasManuallyContactedLead = coachingInquiries =>
  (coachingInquiries ?? []).some(isLeadContacted)

const COMPLETION_CHECKERS = {
  [RECOMMENDED_STEP_IDS.LESSON_PACK]: ({ lessonTypes }) =>
    hasLessonPack(lessonTypes),
  [RECOMMENDED_STEP_IDS.RECURRING_AVAILABILITY]: ({ coachAvailabilities }) =>
    hasRecurringAvailability(coachAvailabilities),
  [RECOMMENDED_STEP_IDS.LEADS_AUTO_REPLY]: ({ preferences }) =>
    Boolean(preferences?.leadAutoReplyEnabled),
  [RECOMMENDED_STEP_IDS.MARK_OFF_PLATFORM_CONTACTS]: ({ coachingInquiries }) =>
    hasManuallyContactedLead(coachingInquiries),
  [RECOMMENDED_STEP_IDS.GROUP_CLINIC]: ({ groupEvents }) =>
    hasActiveGroupEvent(groupEvents),
  [RECOMMENDED_STEP_IDS.ON_COURSE_PLAYING_LESSON]: ({ lessonTypes }) =>
    hasOnCourseLessonType(lessonTypes),
}

export const isRecommendedStepCompleted = (stepId, data) => {
  const checker = COMPLETION_CHECKERS[stepId]

  if (!checker) {
    return false
  }

  return checker(data)
}

export const getRecommendedStepCompletionMap = data => {
  const completionByStepId = {}

  Object.keys(COMPLETION_CHECKERS).forEach(stepId => {
    completionByStepId[stepId] = isRecommendedStepCompleted(stepId, data)
  })

  return completionByStepId
}
